import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const MoreIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "MoreIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M4.16043 14.1607C5.3536 14.1607 6.32086 13.1934 6.32086 12.0003C6.32086 10.8071 5.3536 9.83984 4.16043 9.83984C2.96726 9.83984 2 10.8071 2 12.0003C2 13.1934 2.96726 14.1607 4.16043 14.1607Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 14.1607C13.1932 14.1607 14.1604 13.1934 14.1604 12.0003C14.1604 10.8071 13.1932 9.83984 12 9.83984C10.8068 9.83984 9.83957 10.8071 9.83957 12.0003C9.83957 13.1934 10.8068 14.1607 12 14.1607Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.8396 14.1607C21.0327 14.1607 22 13.1934 22 12.0003C22 10.8071 21.0327 9.83984 19.8396 9.83984C18.6464 9.83984 17.6791 10.8071 17.6791 12.0003C17.6791 13.1934 18.6464 14.1607 19.8396 14.1607Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default MoreIcon;
